'use client';
import React, { useState, useEffect } from 'react';
import { KeyboardArrowUpIcon } from '../icons';
import styles from './ScrollToTopButton.module.css';

export const ScrollToTopButton: React.FC = () => {
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        const toggleVisibility = () => {
            if (window.scrollY > 300) {
                setIsVisible(true);
            } else {
                setIsVisible(false);
            }
        };

        window.addEventListener('scroll', toggleVisibility);

        return () => {
            window.removeEventListener('scroll', toggleVisibility);
        };
    }, []);

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    };

    return (
        <button
            className={`${styles.scrollToTop}${isVisible ? ` ${styles.visible}` : ''}`}
            onClick={scrollToTop}
            aria-label="scroll back to top"
        >
            <KeyboardArrowUpIcon />
        </button>
    );
};
